import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';

export const catalogV2Plugin = createPlugin({
  id: 'catalog-v2',
  routes: {
    root: rootRouteRef,
  },
});

export const CatalogV2PageComponent = catalogV2Plugin.provide(
  createRoutableExtension({
    name: 'CatalogV2PageComponent',
    component: () => import('./catalog/CatalogPage').then(m => m.CatalogPage),
    mountPoint: rootRouteRef,
  }),
);

export const EntityDetailsPageComponent = catalogV2Plugin.provide(
  createRoutableExtension({
    name: 'EntityDetailsPageComponent',
    component: () =>
      import('./entity-details/EntityDetailsPage').then(
        m => m.EntityDetailsPage,
      ),
    mountPoint: rootRouteRef,
  }),
);
